import ModelFactory from 'business/models/ModelFactory';
import {
  ISearchResultDTO,
  SearchResultDTO,
  ISearchDTO,
  SearchDTO,
  SearchTargetDTO,
  SearchnFilterClient,
  WellIngDTO,
  SearchRequestDTO,
  ParentTreeNodeModel,
  SearchFieldDTO,
  FilterDTO,
  FilterOptionsRequestDTO,
  SearchFieldTypeDTO,
  ChartDataRequestDTO,
  ChartDTO,
  TreeClient,
  SearchNodeInfoDTO,
} from 'business/models/Models';
import BaseService from './BaseService';
import { IPaginatedList } from 'components/Pagination/constans';
import {
  transformSearchTargets,
  transformWellIngredients,
} from 'transformers/searchnFilter';
import { getPlainObject, getPlainDto } from 'transformers/utils';

export default class SearchnFilterService extends BaseService {
  async fetchSearchTargets(): Promise<SearchTargetDTO[]> {
    const searchClient: SearchnFilterClient = ModelFactory(
      SearchnFilterClient,
      false,
      true,
    );
    const searchTargets: SearchTargetDTO[] = await searchClient.getTargetNames();

    return transformSearchTargets(searchTargets);
  }

  async fetchTargetRelations(targetId?: number): Promise<{ [key: string]: number[] }> {
    const searchClient: SearchnFilterClient = ModelFactory(
      SearchnFilterClient,
      false,
      true,
    );
    const relatedTargets: { [key: string]: number[] } =
      await searchClient.getSearchTargetRelatedTargets(targetId || 0); // SNF:RFR: Fix this default 0. some issue with TS.

    return relatedTargets;
  }

  async fetchWellDropsListAsWells(
    wellDropIds?: number[],
  ): Promise<IPaginatedList<WellIngDTO>> {
    const searchClient: SearchnFilterClient = ModelFactory(
      SearchnFilterClient,
      false,
      true,
    );
    const _ids = wellDropIds || [];
    const wells: WellIngDTO[] = await searchClient.getWellIngredients(_ids);

    return transformWellIngredients(wells);
  }

  async PerformSearch(searchRequest: SearchRequestDTO): Promise<ISearchResultDTO> {
    const searchClient: SearchnFilterClient = ModelFactory(
      SearchnFilterClient,
      false,
      true,
    );
    const data: SearchResultDTO = await searchClient.getSearchResultData(searchRequest);
    return getPlainObject(data);
  }

  async fetchSearchDetails(id: number): Promise<ISearchDTO> {
    const searchClient: SearchnFilterClient = ModelFactory(
      SearchnFilterClient,
      false,
      true,
    );
    const search: SearchDTO = await searchClient.getSearch(id);

    return getPlainDto(search);
  }

  async createNewSearch(
    parentTreeNodeId: number,
    defaultSearchPathId?: number,
  ): Promise<ISearchDTO> {
    const searchClient: SearchnFilterClient = ModelFactory(SearchnFilterClient);
    const sModel: ParentTreeNodeModel = new ParentTreeNodeModel({
      parentTreeNodeId: parentTreeNodeId,
      defaultSearchPathId: defaultSearchPathId,
    });
    const search: SearchDTO = await searchClient.createSearch(sModel);

    return getPlainDto(search);
  }

  async saveSearch(search: SearchDTO): Promise<boolean> {
    const searchClient: SearchnFilterClient = ModelFactory(SearchnFilterClient);
    return await searchClient.saveSearch(search);
  }

  async getDefaultSelectedSearchFieldsMap(): Promise<{
    [key: string]: SearchFieldDTO[];
  }> {
    const searchClient: SearchnFilterClient = ModelFactory(SearchnFilterClient);
    const response = await searchClient.getDefaultSelectedSearchFields();
    return getPlainDto(response);
  }

  async getSearchFilters(searchId: number): Promise<FilterDTO[]> {
    const searchClient: SearchnFilterClient = ModelFactory(SearchnFilterClient);
    const response = await searchClient.getSearchFilters(searchId);
    return getPlainDto(response);
  }

  async getSearchResultFilterValues(
    request: FilterOptionsRequestDTO,
  ): Promise<SearchFieldTypeDTO> {
    const searchClient: SearchnFilterClient = ModelFactory(SearchnFilterClient);
    const response = await searchClient.getSearchFilterOptions(request);
    return getPlainDto(response);
  }

  async getExperimetnIdByWellId(wellId: number): Promise<number> {
    const searchClient: SearchnFilterClient = ModelFactory(SearchnFilterClient);
    const response = await searchClient.getExperimentIdByWellId(wellId);
    return getPlainDto(response);
  }

  async getExperimetnIdByTreeNodeId(treeNodeId: number): Promise<number> {
    const searchClient: SearchnFilterClient = ModelFactory(SearchnFilterClient);
    const response = await searchClient.getExperimentIdByTreeNodeId(treeNodeId);
    return getPlainDto(response);
  }

  async getExperimetnIdByPlateId(plateId: number): Promise<number> {
    const searchClient: SearchnFilterClient = ModelFactory(SearchnFilterClient);
    const response = await searchClient.getExperimentIdByPlateId(plateId);
    return getPlainDto(response);
  }
  async getSearchChartData(request: ChartDataRequestDTO): Promise<SearchResultDTO> {
    const searchClient: SearchnFilterClient = ModelFactory(SearchnFilterClient);
    const response = await searchClient.getSearchChartData(request);
    return getPlainDto(response);
  }

  async getSearchTargetCharts(): Promise<{ [key: number]: ChartDTO[] }> {
    const searchClient: SearchnFilterClient = ModelFactory(SearchnFilterClient);
    const response = await searchClient.getSearchTargetCharts();
    return getPlainDto(response);
  }

  async getSearchNodeInfo(
    treeNodeId: number,
    signal?: AbortSignal,
  ): Promise<SearchNodeInfoDTO> {
    const treeClient: TreeClient = ModelFactory(TreeClient, false, true, signal);
    const response = await treeClient.getSearchNodeInfo(treeNodeId);
    return getPlainDto(response);
  }
}
